(function() {
  'use strict';

  class WIMInfiniteScrollSimple {
    constructor() {
      this.grid = null;
      this.pagination = null;
      this.nextButton = null;
      this.loader = null;
      this.sentinel = null;
      this.observer = null;
      this.isLoading = false;
      this.loadTriggerRatio = 0.7;
      this.scrollListener = null;
      this.resizeListener = null;
      this.filterCheckInterval = null;

      this.init();
      this.setupFilterListener();
    }

    init() {
      this.teardownObserver();
      this.teardownListeners();

      this.grid = document.querySelector('#CollectionLoop');
      this.pagination = document.querySelector('.pagination-custom');
      this.loader = document.querySelector('[data-infinite-scroll-loader]');
      this.sentinel = document.querySelector('[data-infinite-scroll-sentinel]');

      if (!this.grid) {
        return;
      }

      this.ensureSentinel();

      if (!this.pagination) {
        return;
      }

      this.nextButton = this.pagination.querySelector('.pagination-custom__next');

      if (!this.nextButton || this.nextButton.classList.contains('is-hidden')) {
        return;
      }

      this.pagination.style.display = 'none';

      // S18/L05: si hay botón "Cargar más", se carga bajo demanda (sin scroll infinito) para poder llegar al pie
      this.loadMoreBtn = document.querySelector('[data-wim-load-more-btn]');
      if (this.loadMoreBtn) {
        if (!this.loadMoreBtn.dataset.wimBound) {
          this.loadMoreBtn.dataset.wimBound = '1';
          this.loadMoreBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.loadNextPage();
          });
        }
        return;
      }

      this.setupObserver();
      this.bindResize();
    }

    updateLoadMore(doc) {
      const box = document.querySelector('[data-wim-load-more]');
      if (!box) {
        return;
      }
      const newBox = doc.querySelector('[data-wim-load-more]');
      const seenEl = box.querySelector('[data-wim-seen]');
      const barEl = box.querySelector('[data-wim-bar]');
      const total = parseInt(box.dataset.total, 10) || 0;
      const newSeen = newBox ? parseInt(newBox.querySelector('[data-wim-seen]').textContent, 10) : total;
      if (seenEl) seenEl.textContent = newSeen;
      if (barEl && total) barEl.style.width = Math.min(100, Math.round(newSeen * 100 / total)) + '%';

      const newBtn = newBox ? newBox.querySelector('[data-wim-load-more-btn]') : null;
      if (this.loadMoreBtn) {
        if (newBtn) {
          this.loadMoreBtn.setAttribute('href', newBtn.getAttribute('href'));
          this.loadMoreBtn.removeAttribute('aria-busy');
        } else {
          this.loadMoreBtn.remove();
          this.loadMoreBtn = null;
        }
      }
    }

    ensureSentinel() {
      const productsGrid = document.querySelector('[data-products-grid]');
      if (this.sentinel && productsGrid && productsGrid.contains(this.sentinel)) {
        return;
      }
      if (!productsGrid) {
        return;
      }

      this.sentinel = document.createElement('div');
      this.sentinel.className = 'infinite-scroll-sentinel';
      this.sentinel.setAttribute('data-infinite-scroll-sentinel', '');
      this.sentinel.setAttribute('aria-hidden', 'true');

      const loader = productsGrid.querySelector('[data-infinite-scroll-loader]');
      if (loader) {
        productsGrid.insertBefore(this.sentinel, loader);
      } else {
        productsGrid.appendChild(this.sentinel);
      }
    }

    getPrefetchMargin() {
      const gridHeight = this.grid ? this.grid.offsetHeight : 0;
      const marginRatio = 1 - this.loadTriggerRatio;
      return Math.max(200, Math.round(gridHeight * marginRatio));
    }

    onIntersect(entries) {
      const entry = entries[0];
      if (!entry || !entry.isIntersecting) {
        return;
      }

      if (this.isLoading || !this.nextButton || this.nextButton.classList.contains('is-hidden')) {
        return;
      }

      this.loadNextPage();
    }

    setupObserver() {
      if (!this.sentinel || !('IntersectionObserver' in window)) {
        this.setupScrollFallback();
        return;
      }

      const margin = this.getPrefetchMargin();

      this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
        root: null,
        rootMargin: `0px 0px ${margin}px 0px`,
        threshold: 0,
      });

      this.observer.observe(this.sentinel);
    }

    updateObserverRootMargin() {
      if (!this.observer || !this.sentinel) {
        return;
      }

      this.observer.disconnect();
      this.setupObserver();
    }

    setupScrollFallback() {
      this.scrollListener = this.debounce(() => this.checkGridScroll(), 100);
      window.addEventListener('scroll', this.scrollListener);
      setTimeout(() => this.checkGridScroll(), 500);
    }

    checkGridScroll() {
      if (this.isLoading || !this.sentinel || !this.nextButton || this.nextButton.classList.contains('is-hidden')) {
        return;
      }

      const sentinelTop = this.sentinel.getBoundingClientRect().top;
      const triggerLine = window.innerHeight + this.getPrefetchMargin();

      if (sentinelTop <= triggerLine) {
        this.loadNextPage();
      }
    }

    bindResize() {
      if (this.resizeListener) {
        window.removeEventListener('resize', this.resizeListener);
      }

      this.resizeListener = this.debounce(() => {
        if (this.observer) {
          this.updateObserverRootMargin();
        } else {
          this.checkGridScroll();
        }
      }, 150);

      window.addEventListener('resize', this.resizeListener);
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    isAppendableNode(node) {
      if (!node || node.tagName === 'SCRIPT') {
        return false;
      }

      if (node.classList && node.classList.contains('no-results')) {
        return false;
      }

      return !node.hasAttribute('data-infinite-scroll-loader') &&
        !node.hasAttribute('data-infinite-scroll-sentinel');
    }

    async loadNextPage() {
      if (!this.nextButton || this.isLoading) {
        return;
      }

      this.isLoading = true;

      if (this.loader) {
        this.loader.style.display = 'block';
        this.loader.style.visibility = 'visible';
        this.loader.style.opacity = '1';
      }

      try {
        if (this.loadMoreBtn) this.loadMoreBtn.setAttribute('aria-busy', 'true');
        const nextUrl = (this.loadMoreBtn || this.nextButton).getAttribute('href');
        if (!nextUrl) {
          throw new Error('No se encontró URL de siguiente página');
        }

        const response = await fetch(nextUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.querySelector('#CollectionLoop');
        if (newGrid) {
          const newProducts = Array.from(newGrid.children);

          newProducts.forEach((product) => {
            if (this.isAppendableNode(product)) {
              this.grid.appendChild(product);
            }
          });
        }

        this.updateLoadMore(doc);

        const newPagination = doc.querySelector('.pagination-custom');
        if (newPagination) {
          const newNextButton = newPagination.querySelector('.pagination-custom__next');

          if (newNextButton && !newNextButton.classList.contains('is-hidden')) {
            this.nextButton.setAttribute('href', newNextButton.getAttribute('href'));
          } else {
            this.nextButton.classList.add('is-hidden');
            this.nextButton = null;
            this.teardownObserver();
          }
        }

        setTimeout(() => {
          if (this.loader) {
            this.loader.style.display = 'none';
            this.loader.style.visibility = 'hidden';
            this.loader.style.opacity = '0';
          }

          this.isLoading = false;
          if (!this.loadMoreBtn) this.updateObserverRootMargin();
        }, 300);
      } catch (error) {
        console.error('WIM Infinite Scroll: Error al cargar más productos:', error);

        if (this.loader) {
          this.loader.style.display = 'none';
          this.loader.style.visibility = 'hidden';
          this.loader.style.opacity = '0';
        }

        this.isLoading = false;
      }
    }

    setupFilterListener() {
      if (this.filterCheckInterval) {
        return;
      }

      const productsContainer = document.querySelector('[data-products-grid]');
      if (!productsContainer) {
        return;
      }

      let lastPaginationHTML = '';
      let lastPaginationExists = false;

      this.filterCheckInterval = setInterval(() => {
        if (this.isLoading) {
          return;
        }

        const pagination = document.querySelector('.pagination-custom');
        const paginationExists = !!pagination;

        if (paginationExists !== lastPaginationExists) {
          lastPaginationExists = paginationExists;
          if (paginationExists) {
            setTimeout(() => this.init(), 500);
          }
          return;
        }

        if (pagination) {
          const currentHTML = pagination.innerHTML;
          if (currentHTML !== lastPaginationHTML && lastPaginationHTML !== '') {
            setTimeout(() => this.init(), 500);
          }
          lastPaginationHTML = currentHTML;
        } else {
          lastPaginationHTML = '';
        }
      }, 1000);
    }

    teardownObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    teardownListeners() {
      if (this.scrollListener) {
        window.removeEventListener('scroll', this.scrollListener);
        this.scrollListener = null;
      }

      if (this.resizeListener) {
        window.removeEventListener('resize', this.resizeListener);
        this.resizeListener = null;
      }
    }

    destroy() {
      this.teardownObserver();
      this.teardownListeners();

      if (this.filterCheckInterval) {
        clearInterval(this.filterCheckInterval);
        this.filterCheckInterval = null;
      }
    }
  }

  function initInfiniteScroll() {
    setTimeout(() => {
      try {
        new WIMInfiniteScrollSimple();
      } catch (error) {
        console.error('Error al inicializar WIM Infinite Scroll:', error);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }
})();
